import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import * as Sentry from '@sentry/angular';

export interface SentryLogOptions {
  extras?: Record<string, any>;
  context?: { name: string; data: Record<string, unknown> };
  tags?: Record<string, string>;
  severityLevel?: Sentry.SeverityLevel;
}

@Injectable({ providedIn: 'root' })
export class LoggingService {
  appInsights: ApplicationInsights;
  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        disableDataLossAnalysis: false,
      }
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) { 
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number, properties?: { [key: string]: any }) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel }, properties);
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message}, properties);
  }

  logExceptionSentry(error: any, properities?: SentryLogOptions)
  {
    let id = Sentry.withScope(scope => {
      scope.setContext(properities?.context?.name, properities?.context?.data)
      scope.setTags(properities?.tags)
      scope.setExtras(properities?.extras);
      scope.setLevel(properities?.severityLevel);
      return Sentry.captureException(error instanceof Error ? error : new Error(error));
    });

    this.logException(error, undefined, { "Sentry Trace ID": id });
  }
}

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

  constructor(private loggingService: LoggingService) {
      super();
  }

  handleError(error: any) {
    const id = Sentry.captureException(error instanceof Error ? error : new Error(error));

    this.loggingService.logException(error, undefined, { "Sentry Trace ID": id });
  }

    
}